// Glow cart drawer. Uses Shopify's Ajax Cart API. Exposes window.GlowCart.open() / .close() / .refresh().
(function () {
  const root = document.getElementById('GlowCart');
  if (!root) return;
  const D = JSON.parse(document.getElementById('GlowCartData').textContent);
  const R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = id => document.getElementById(id);
  const money = c => (D.moneyFormat || '£{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2)).replace(/<[^>]*>/g, '');
  const products = {};
  const piecesOf = t => { const m = /(\d+)\s*piece/i.exec(t || ''); return m ? Number(m[1]) : null; };
  // Free gifts: the mat tile (D.giftId, 6+ stones) and the Glow Sensory Spinner (4+ stones). Gift lines carry _glow_gift;
  // the spinner is also recognised by its variant id, in case it got in without the property.
  let spinnerId = D.spinnerId || null;
  const isSpinner = i => !!spinnerId && i.variant_id === spinnerId;
  const isMat = i => !!D.giftId && i.variant_id === D.giftId;
  const isGift = i => !!(i.properties && i.properties._glow_gift) || isSpinner(i) || isMat(i);
  // Gift ladder, counted in stones (sets = their pieces, single stones = 1 each). Same steps as the product page.
  const LADDER = [
    { n: 3, label: 'Free delivery', what: '<b>FREE delivery</b>' },
    { n: 4, label: 'Free spinner', what: 'a <b>FREE Glow Sensory Spinner</b> 🎁' },
    { n: 6, label: '2 free gifts', what: '<b>2 free gifts</b> 🎁🎁' },
  ];
  const nextStep = n => LADDER.find(s => s.n > n);
  const spinnerDot = '<svg class="gcart__dot" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true"><defs><radialGradient id="gcartGlow" cx="50%" cy="45%" r="50%"><stop offset="0" stop-color="#FFF4C2"/><stop offset=".45" stop-color="#F7B267"/><stop offset=".8" stop-color="#EF6C2F" stop-opacity=".55"/><stop offset="1" stop-color="#EF6C2F" stop-opacity="0"/></radialGradient></defs><circle cx="32" cy="32" r="30" fill="url(#gcartGlow)"/><circle cx="32" cy="30" r="11" fill="#fff" fill-opacity=".85"/></svg>';
  const isProtect = i => D.protectId && i.variant_id === D.protectId;
  // 14 Oct (Glow Pad): pre-order products carry the tag D.preorderTag (read from /products/<handle>.js); their dispatch note comes
  // from a product metafield rendered into D.preorderNotes (or D.preorderFallback).
  const PRE_TAG = String(D.preorderTag || '').toLowerCase();
  const isPre = p => !!PRE_TAG && !!p && Array.isArray(p.tags) && p.tags.some(t => String(t).toLowerCase() === PRE_TAG);
  const preNote = h => (D.preorderNotes && D.preorderNotes[h]) || D.preorderFallback || 'Pre-order';
  const preLines = new Map(); // line key -> dispatch note, filled while rendering the items
  // the single stone is the sets product's 1-piece variant; its shape + colour ride along as line item properties
  const isSingle = i => (D.singleId && i.variant_id === D.singleId) || (i.handle === D.setHandle && piecesOf(i.variant_title) === 1);
  const prop = (i, k) => (i.properties && i.properties[k]) || '';
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // One real review for the reassurance block, read from the reviews data file (assets/glow-reviews-<handle>.json).
  // Pinned by id in the section settings, else the shortest 5-star review from the store's own reviews. No file = no review.
  let review; // undefined: not loaded yet, null: none to show
  async function loadReview() {
    if (review !== undefined) return review;
    review = null;
    if (!D.reviewsUrl) return review;
    try {
      const r = await fetch(D.reviewsUrl);
      if (!r.ok) return review;
      const list = ((await r.json()).reviews || []).filter(x => x && x.b && x.n);
      review = (D.reviewId && list.find(x => x.id === D.reviewId && x.r >= 4))
        || list.filter(x => x.r >= 5 && !x.s && x.b.length <= 110).sort((a, b) => a.b.length - b.b.length)[0] || null;
    } catch (e) { review = null; }
    return review;
  }
  const singleImg = i => {
    const shape = prop(i, 'Shape'), colour = prop(i, 'Colour');
    if (!D.singleImgBase || !shape || !colour) return null;
    const slug = colour.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return D.singleImgBase + shape.trim().split(/\s+/).pop().toLowerCase() + '-' + slug + '.jpg?width=200';
  };

  async function product(handle) {
    if (!(handle in products)) {
      try { products[handle] = await (await fetch(`${R}products/${handle}.js`)).json(); }
      catch (e) { products[handle] = null; }
    }
    return products[handle];
  }
  async function api(path, body) {
    const r = await fetch(R + path, body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error(await r.text());
    return r.json();
  }

  // stones in the cart: sets count as their pieces ("Adventure (6 pieces)" = 6), single stones 1 each; gifts and other products 0
  const stonesIn = cart => cart.items.reduce((a, i) => {
    if (isGift(i) || isProtect(i) || i.handle !== D.setHandle) return a;
    return a + (isSingle(i) ? 1 : (piecesOf(i.variant_title) || 0)) * i.quantity;
  }, 0);

  // 15 Oct (Glow Pad 2-pack offer): D.padGift = { handle, min, name }. With `min`+ Glow Pads in the cart ("2 Glow Pads" counts 2,
  // "1 Glow Pad" counts 1 per quantity) the cart gets 1 free mat tile (the same £0 gift product, D.giftId), max 1 per order,
  // on top of the stones' own tile at 6+ stones. Carts without the pad are unchanged.
  const PAD = D.padGift && D.padGift.handle ? D.padGift : null;
  const padUnits = cart => !PAD ? 0 : cart.items.reduce((a, i) => {
    if (isGift(i) || i.handle !== PAD.handle) return a;
    const m = /^\s*(\d+)/.exec(i.variant_title || '');
    return a + (m ? Number(m[1]) : 1) * i.quantity;
  }, 0);
  const padTile = cart => (PAD && padUnits(cart) >= (Number(PAD.min) || 2) ? 1 : 0);

  // Gift sync: the gifts are £0 products, so the stone count alone decides who gets them. Exactly 1 Glow Sensory Spinner at 4+ stones,
  // 1 mat tile at 6+, none below; any extra quantity (or a gift added by hand) is clamped. One pass per render, so no loops;
  // if adding a gift fails (e.g. sold out) it isn't retried until the stone count changes.
  // 15 Oct: + 1 mat tile with 2+ Glow Pads (padTile), so a mixed cart can have 2.
  const blocked = new Set();
  const bkey = (id, stones) => id + '@' + stones;
  async function spinnerVariant() {
    if (spinnerId || !D.spinnerHandle) return spinnerId;
    const p = await product(D.spinnerHandle);
    const v = p && p.variants && (p.variants.find(x => x.available) || p.variants[0]);
    spinnerId = v ? v.id : null;
    return spinnerId;
  }
  async function syncGifts(cart) {
    const stones = stonesIn(cart), pt = padTile(cart);
    const bk = pt ? stones + '+pad' : stones; // failed-add memory: also retried when the pad tile switches on/off
    const want = [];
    try { await spinnerVariant(); } catch (e) {}
    if (spinnerId) want.push({ id: spinnerId, qty: stones >= LADDER[1].n ? 1 : 0, match: i => i.variant_id === spinnerId });
    if (D.giftId) want.push({ id: D.giftId, qty: (stones >= LADDER[2].n ? 1 : 0) + pt, match: isMat });
    const updates = {}, adds = [];
    want.forEach(w => {
      let have = 0;
      cart.items.filter(w.match).forEach(l => {
        const keep = Math.max(0, Math.min(l.quantity, w.qty - have));
        have += keep;
        if (keep !== l.quantity) updates[l.key] = keep;
      });
      if (have < w.qty && !blocked.has(bkey(w.id, bk))) adds.push({ id: w.id, quantity: w.qty - have, properties: { _glow_gift: '1' } });
    });
    if (Object.keys(updates).length) cart = await api('cart/update.js', { updates });
    if (adds.length) {
      try { await api('cart/add.js', { items: adds }); } catch (e) { adds.forEach(a => blocked.add(bkey(a.id, bk))); }
      cart = await api('cart.js');
    }
    return cart;
  }

  // coupon state from /cart.js: 'applied' (code on the cart and applicable), 'blocked' (on the cart but not applicable), or ''
  let couponNote = false; // one-off "can't be used" note after an Apply that didn't take
  function couponState(cart, code) {
    if (!code) return '';
    const lc = code.toLowerCase();
    const dc = (cart.discount_codes || []).find(d => String(d.code || '').toLowerCase() === lc);
    const app = (cart.cart_level_discount_applications || []).some(d => String(d.title || '').toLowerCase() === lc);
    if (app || (dc && dc.applicable)) return 'applied';
    return dc && cart.item_count ? 'blocked' : '';
  }

  let fixing = false;
  async function render(cart) {
    cart = cart || await api('cart.js');

    // gifts follow the stone count; drop protection if it's the only thing left
    if (!fixing) {
      fixing = true;
      try {
        cart = await syncGifts(cart);
        const lonely = cart.items.length && cart.items.every(i => isProtect(i) || isGift(i)) ? cart.items.find(isProtect) : null;
        if (lonely) cart = await api('cart/change.js', { id: lonely.key, quantity: 0 });
        // gifts left on their own (cart emptied) go too
        if (cart.items.length && cart.items.every(isGift)) {
          const off = {}; cart.items.forEach(i => { off[i.key] = 0; });
          cart = await api('cart/update.js', { updates: off });
        }
      } catch (e) { console.error(e); } finally { fixing = false; }
    }

    const real = cart.items.filter(i => !isGift(i) && !isProtect(i));
    const count = real.reduce((a, i) => a + i.quantity, 0);
    $('GlowCartN').textContent = count; $('GlowCartN').hidden = !count;
    document.querySelectorAll('#GlowCartCount').forEach(el => { el.textContent = count; el.hidden = count === 0; });
    const goodsNoGift = real.reduce((a, i) => a + i.final_line_price, 0);
    const goods = goodsNoGift + cart.items.filter(isGift).reduce((a, i) => a + i.final_line_price, 0);

    // gift ladder: "Add 1 more stone for a FREE Glow Sensory Spinner", three segments with ticks for what's unlocked
    const stones = stonesIn(cart), nx = nextStep(stones);
    const more = nx ? nx.n - stones : 0;
    let prev = 0;
    const segs = LADDER.map(s => {
      const fill = Math.max(0, Math.min(1, (stones - prev) / (s.n - prev))); prev = s.n;
      const on = stones >= s.n;
      return `<li class="${on ? 'is-on' : ''}${nx && nx.n === s.n ? ' is-next' : ''}"><i><u style="width:${Math.round(fill * 100)}%"></u></i><span>${on ? '✓ ' : ''}${s.label}</span></li>`;
    }).join('');
    // 14 Oct (Glow Pad): the ladder is about stones, so it only shows when the cart has stones. A cart with only other
    // products (e.g. the Glow Pad) gets no ladder; stones + other products work exactly as a stones-only cart.
    $('GlowCartShip').innerHTML = !count || !stones ? '' :
      `<p class="gcart__ladder-h">${nx
        ? `Add <em>${more} more stone${more > 1 ? 's' : ''}</em> for ${nx.what}`
        : '<b>Free delivery + 2 free gifts unlocked</b> 🎉'}</p><ol class="gcart__ladder" aria-label="${stones} stone${stones === 1 ? '' : 's'} in your cart">${segs}</ol>`;

    // items + savings from compare-at prices
    let was = 0; let upgrade = null;
    preLines.clear();
    const rows = await Promise.all(cart.items.filter(i => !isProtect(i)).map(async i => {
      const gift = isGift(i);
      const p = gift ? null : await product(i.handle);
      const v = p && p.variants.find(x => x.id === i.variant_id);
      const single = isSingle(i);
      const cmp = v && !single && v.compare_at_price > v.price ? v.compare_at_price * i.quantity : i.original_line_price;
      // gifts aren't sold, so their list price never counts towards "You saved" (no "worth £X" claims)
      was += gift ? i.final_line_price : cmp;
      const spin = gift && isSpinner(i);
      const pre = !gift && isPre(p);
      if (pre) preLines.set(i.key, preNote(i.handle));
      // next set up, for the upgrade nudge (14 Oct: stone sets only, so another product never takes the stones' upgrade card)
      if (p && v && p.variants.length > 1 && !upgrade && !single && i.handle === D.setHandle) {
        const idx = p.variants.findIndex(x => x.id === v.id);
        const next = p.variants.slice(idx + 1).find(x => x.available && piecesOf(x.title) !== 1);
        if (next) upgrade = { line: i, from: v, to: next };
      }
      const line = cart.items.indexOf(i) + 1;
      const pcs = single ? null : piecesOf(i.variant_title);
      const img = spin ? (D.spinnerImg || i.image || null) : gift ? (D.giftImg || i.image) :((single && singleImg(i)) || (v && v.featured_image && v.featured_image.src) || (pcs && D.setImages[pcs]) || i.image);
      const codes = (i.line_level_discount_allocations || []).filter(a => a.amount > 0).map(a => a.discount_application && a.discount_application.title).filter(t => t && !gift);
      const src = img && !/cdn\/shop\/t\//.test(img) && !/assets\//.test(img) && !/[?&]width=/.test(img) ? img.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : img;
      const full = gift ? i.final_line_price : cmp;
      const saved = full - i.final_line_price;
      const setName = !gift && i.variant_title ? i.variant_title.replace(/\s*\(.*\)\s*/, '') : '';
      const singleName = single ? ([prop(i, 'Shape'), prop(i, 'Colour')].filter(Boolean).join(' · ') || 'Single stone') : '';
      const priceHtml = `<div class="gcart__price">${saved > 0 ? `<s>${money(full)}</s>` : ''}<b>${i.final_line_price === 0 ? 'FREE' : money(i.final_line_price)}</b></div>`;
      if (gift) return { gift: true, html: `<li class="gcart__gift">
        <span class="gcart__gift-img">${src ? `<img src="${src}" alt="" width="48" height="48">` : spin ? spinnerDot : ''}</span>
        <span class="gcart__gift-txt"><b>${spin ? (D.spinnerName || 'Glow Sensory Spinner') : (!stones && PAD && PAD.name ? esc(PAD.name) : 'Sensory mat tile') + (i.quantity > 1 ? ' × ' + i.quantity : '')}</b><span>${spin ? 'Light-up press-to-spin ball' : (i.quantity > 1 ? i.quantity + ' liquid gel tiles' : '1 liquid gel tile')}</span></span>
        <em>${i.final_line_price === 0 ? 'FREE' : money(i.final_line_price)}</em>
      </li>` };
      return { gift: false, html: `<li class="gcart__item">
        <div class="gcart__img">${src ? `<img src="${src}" alt="" width="88" height="88">` : spin ? spinnerDot : '<img src="" alt="" width="88" height="88">'}</div>
        <div class="gcart__info">
          <p class="gcart__kick">${gift ? 'Free gift' : single ? 'Single stone' : i.product_title}</p>
          <p class="gcart__name">${spin ? (D.spinnerName || 'Glow Sensory Spinner') : gift ? 'Sensory mat tile' : single ? singleName : (setName ? setName + (i.handle === D.setHandle ? ' set' : '') : i.product_title)}${pcs ? ` <span>· ${pcs} pieces</span>` : ''}</p>
          ${spin ? '<p class="gcart__var">Light-up press-to-spin ball · yours free</p>' : gift ? '<p class="gcart__var">1 liquid gel tile · yours free</p>' : ''}${pre ? `<p class="gcart__var gcart__pre">${esc(preNote(i.handle))}</p>` : ''}
          <div class="gcart__tags">${saved > 0 && !gift ? `<span class="gcart__save">You save ${money(saved)}</span>` : ''}${codes.map(c => `<span class="gcart__pill"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12l-8 8-9-9V3h8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>${c}</span>`).join('')}</div>
          <div class="gcart__row">${gift ? '<span></span>' : `<div class="gcart__qty">
            <button type="button" data-line="${line}" data-q="${i.quantity - 1}" aria-label="Decrease">−</button>
            <span>${i.quantity}</span>
            <button type="button" data-line="${line}" data-q="${i.quantity + 1}" aria-label="Increase">+</button>
          </div>`}${priceHtml}</div>
        </div>
        ${gift ? '' : `<button type="button" class="gcart__rm" data-line="${line}" data-q="0" aria-label="Remove"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button>`}
      </li>` };
    }));
    // paid items first, then the free gifts grouped underneath (Shopify lists the newest line first, which put the gifts on top)
    $('GlowCartItems').innerHTML = rows.filter(r => !r.gift).map(r => r.html).join('');
    const giftRows = rows.filter(r => r.gift);
    const gEl = $('GlowCartGifts');
    gEl.hidden = !giftRows.length || !count;
    gEl.innerHTML = giftRows.length ? `<p class="gcart__gifts-h"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>Included free<span>${giftRows.length} gift${giftRows.length > 1 ? 's' : ''}</span></p><ul>${giftRows.map(r => r.html).join('')}</ul>` : '';
    $('GlowCartEmpty').hidden = count > 0;

    // upgrade nudge: "Add N more pieces – save £X + free gift" (perks follow the stone ladder)
    const nudge = $('GlowCartNudge');
    nudge.classList.remove('is-done');
    if (upgrade && upgrade.line.quantity === 1) {
      const { from, to } = upgrade;
      const toPcs = piecesOf(to.title), morePieces = (toPcs || 0) - (piecesOf(from.title) || 0);
      const extra = to.price - from.price;
      const saveFrom = from.compare_at_price > from.price ? from.compare_at_price - from.price : 0;
      const saveTo = to.compare_at_price > to.price ? to.compare_at_price - to.price : 0;
      const after = stones + Math.max(0, morePieces);
      const freeShip = stones < LADDER[0].n && after >= LADDER[0].n;
      const spinUp = stones < LADDER[1].n && after >= LADDER[1].n;
      const gift = stones < LADDER[2].n && after >= LADDER[2].n; // unlocks the 2nd gift (mat tile)
      const prod = Object.values(products).find(p => p && p.variants.some(v => v.id === to.id));
      const giftVar = prod && !gift ? prod.variants.find(v => v.title === D.giftUnlock && v.available && v.id !== from.id) : null;
      const perks = [];
      if (saveTo) perks.push(`Total savings rise to <b>${money(saveTo)}</b>`);
      if (freeShip) perks.push(`<b>Free UK delivery</b>${D.shippingValue ? ` (save ${money(D.shippingValue)})` : ''}`);
      if (spinUp) perks.push('<b>Free Glow Sensory Spinner</b> 🎁');
      if (gift) perks.push(spinUp ? '<b>Free sensory mat tile</b> too 🎁' : '<b>2nd free gift:</b> a sensory mat tile 🎁');
      const value = (saveTo - saveFrom) + (freeShip ? D.shippingValue : 0);
      nudge.hidden = false;
      nudge.innerHTML = `<div class="gcart__up-card">
          <div class="gcart__up-img">${toPcs && D.setImages[toPcs] ? `<img src="${D.setImages[toPcs]}" alt="" width="96" height="96">` : ''}</div>
          <div class="gcart__up-txt">
            <p class="gcart__up-kicker">Upgrade &amp; save</p>
            <p class="gcart__up-h">Add ${morePieces > 0 ? morePieces + ' more piece' + (morePieces > 1 ? 's' : '') : 'the ' + to.title} ${value > 0 ? `and save <em>${money(value)}</em> more` : ''}</p>
            <ul>${perks.map(p => `<li>${p}</li>`).join('')}</ul>
          </div>
        </div>
        <button type="button" class="gcart__up-btn" data-upgrade="${upgrade.line.key}" data-to="${to.id}">Upgrade to ${toPcs ? toPcs + ' pieces' : to.title} · +${money(extra)}</button>
        ${giftVar && stones < LADDER[2].n ? `<button type="button" class="gcart__tease" data-upgrade="${upgrade.line.key}" data-to="${giftVar.id}">${D.giftImg ? `<img src="${D.giftImg}" alt="" width="36" height="36">` : ''}<span>Or go to <b>${piecesOf(giftVar.title) || ''} pieces</b> and get <b>2 free gifts</b> · +${money(giftVar.price - from.price)}</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>` : ''}`;
    } else { nudge.hidden = true; nudge.innerHTML = ''; }
    // 27 Oct (Glow Wand add-on): one-click "Pair it with a Glow Wand" row when the cart has stones or a Glow Pad (D.wand.with)
    // and no wand. Opt-in only: nothing is added until the shopper taps Add. The £9.99 is an automatic discount in Shopify,
    // so the line price comes from the cart; D.wand.addon is only the label. Other carts: the row stays empty and hidden.
    const wEl = $('GlowCartWand'), W = D.wand;
    if (wEl) {
      const withH = W ? String(W.with || '').split(',').map(x => x.trim()).filter(Boolean) : [];
      const showW = !!W && !!W.available && count > 0 && real.some(i => withH.indexOf(i.handle) > -1) && !cart.items.some(i => i.handle === W.handle);
      wEl.hidden = !showW;
      wEl.innerHTML = !showW ? '' : `<div class="gcart__wand-img">${W.img ? `<img src="${W.img}" alt="" width="56" height="56">` : ''}</div>
        <div class="gcart__wand-txt"><b>${esc(W.title)}</b><span>${esc(W.line)} · <b>${money(W.addon)}</b> with your order <small>(${money(W.price)} on its own)</small></span>${W.pre ? `<small class="gcart__wand-pre">${esc(W.pre)}</small>` : ''}</div>
        <button type="button" class="gcart__wand-btn" data-wand-add="${W.id}" aria-label="Add a Glow Wand for ${money(W.addon)}">Add<small>${money(W.addon)}</small></button>`;
      // 30 Oct (Glow Pad upsell): same slot, one row at a time. When the wand row isn't showing (wand already in the cart, or
      // not available) and the cart has stones (D.pad.with) but no Glow Pad: "Add a Glow Pad" at its full price, with its
      // pre-order note so a mixed order is clear. Opt-in only, nothing is added until the shopper taps Add.
      const P = D.pad;
      const withP = P ? String(P.with || '').split(',').map(x => x.trim()).filter(Boolean) : [];
      const showP = !showW && !!P && !!P.available && count > 0 && real.some(i => withP.indexOf(i.handle) > -1) && !cart.items.some(i => i.handle === P.handle);
      if (showP) {
        wEl.hidden = false;
        wEl.innerHTML = `<div class="gcart__wand-img">${P.img ? `<img src="${P.img}" alt="" width="56" height="56">` : ''}</div>
        <div class="gcart__wand-txt"><b>${esc(P.title)}</b><span>${esc(P.line)} · <b>${money(P.price)}</b></span>${P.pre ? `<small class="gcart__wand-pre">${esc(String(P.pre).replace(/^Pre-order:\s*/i, 'Pre-order · ').split(',')[0])}</small>` : ''}</div>
        <button type="button" class="gcart__wand-btn" data-pad-add="${P.id}" aria-label="Add a Glow Pad for ${money(P.price)}">Add<small>${money(P.price)}</small></button>`;
      }
    }
    // singles in the cart: "Add 1 more stone for a FREE Glow Sensory Spinner" with a one-tap +1 on the last single line,
    // up to the top of the ladder. With no next step: one short line to the set price per stone (if a set is cheaper).
    const sEl = $('GlowCartSingle');
    const singles = cart.items.filter(isSingle);
    const nSingles = singles.reduce((a, i) => a + i.quantity, 0);
    const hasSet = cart.items.some(i => i.handle === D.setHandle && !isSingle(i) && !isGift(i));
    const sPrice = singles.length ? singles[singles.length - 1].final_price || singles[singles.length - 1].price : 0;
    if (sEl && nSingles && nx && sPrice && !(hasSet && upgrade && upgrade.line.quantity === 1)) {
      const last = singles[singles.length - 1];
      const what = [prop(last, 'Colour'), (prop(last, 'Shape') || '').toLowerCase()].filter(Boolean).join(' ');
      const sub = nx.n === LADDER[0].n ? `Unlocks free delivery${D.shippingValue ? ` (save ${money(D.shippingValue)})` : ''}` : nx.n === LADDER[1].n ? 'Unlocks a free Glow Sensory Spinner 🎁' : 'Unlocks 2 free gifts 🎁🎁';
      sEl.hidden = false; sEl.classList.add('is-ship');
      sEl.innerHTML = `<div class="gcart__single-txt"><b>${more === 1 ? 'Add another stone' : `Add ${more} more stones`}</b><span>${sub}</span></div><button type="button" class="gcart__plus1" data-key="${last.key}" data-q="${last.quantity + 1}" aria-label="Add another ${what || 'stone'}">+1 stone<small>${money(sPrice)}</small></button>`;
    } else {
      const target = nSingles && !hasSet && D.setUrl
        ? (D.sets || []).filter(s => s.available && s.per < sPrice).sort((a, b) => a.pieces - b.pieces).find(s => s.pieces > nSingles) : null;
      if (sEl && target) {
        sEl.hidden = false; sEl.classList.remove('is-ship');
        sEl.innerHTML = `<p>Getting ${target.pieces}? The <b>${target.name} set</b> works out at ${money(target.per)}/stone</p><a href="${D.setUrl}?variant=${target.id}">See ${target.name} <span aria-hidden="true">→</span></a>`;
      } else if (sEl) { sEl.hidden = true; sEl.innerHTML = ''; sEl.classList.remove('is-ship'); }
    }

    // coupon line above the subtotal, read from /cart.js on every render:
    // "Code WelcomeGlow10 = 10% off [Apply]" → "✓ WelcomeGlow10 applied · 10% off [Remove]", or a short note if the cart can't use it
    const cEl = $('GlowCartCoupon');
    if (cEl) {
      const code = D.coupon || '';
      const st = couponState(cart, code);
      cEl.hidden = !code || !count;
      cEl.classList.toggle('is-applied', st === 'applied');
      cEl.classList.toggle('is-bad', st === 'blocked' || couponNote);
      cEl.innerHTML = !code ? '' : st === 'applied'
        ? `<span class="gcart__coupon-t"><span aria-hidden="true">✓</span> <b>${code}</b> applied · 10% off</span><button type="button" class="gcart__coupon-rm" data-unapply>Remove</button>`
        : `<span class="gcart__coupon-t">Code <b>${code}</b> = 10% off<span class="gcart__coupon-x"> at checkout</span></span><a href="${R}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(location.pathname)}" data-apply="${code}">Apply</a>`
          + (st === 'blocked' || couponNote ? `<small class="gcart__coupon-note" role="status">This code can’t be used with this cart</small>` : '');
      couponNote = false;
    }

    // upsells not already in the cart
    const inCart = new Set(cart.items.map(i => i.variant_id));
    const ups = D.upsells.filter(u => u.available && !inCart.has(u.id));
    $('GlowCartUps').hidden = !ups.length || !count;
    $('GlowCartUpsList').innerHTML = ups.map(u => `
      <div class="gcart__up"><img src="${u.img || ''}" alt="" width="52" height="52">
        <div><b>${u.title}</b><span>${money(u.price)}</span></div>
        <button type="button" data-add="${u.id}">Add</button></div>`).join('');

    // shipping protection (opt-in, never pre-ticked)
    const prot = cart.items.find(isProtect);
    $('GlowCartProtect').hidden = !D.protectId || !D.protectAvailable || !count;
    $('GlowCartProtectPrice').textContent = '+' + money(D.protectPrice);
    $('GlowCartProtectToggle').checked = !!prot;

    // delivery line: FREE only when the cart really qualifies (3+ stones and over the free-delivery threshold), otherwise left to checkout.
    // 14 Oct (Glow Pad): other products (not stones) qualify on the threshold alone, like Shopify's free-over-£72 rate; a cart with only
    // pre-order goods shows the dispatch note instead of the delivery time. Stones-only carts are unchanged.
    const dEl = $('GlowCartDelivery');
    const otherGoods = real.filter(i => i.handle !== D.setHandle);
    const freeShip = (stones >= LADDER[0].n || otherGoods.length > 0) && cart.total_price >= (D.threshold || 0);
    const preOnly = real.length > 0 && real.every(i => preLines.has(i.key));
    dEl.hidden = !count;
    dEl.innerHTML = preOnly
      ? `<span>Delivery <small>· ${esc(preLines.get(real[0].key))}</small></span>${freeShip ? '<b class="is-free">FREE</b>' : '<span class="gcart__line-r">Calculated at checkout</span>'}`
      : freeShip
      ? `<span>UK delivery${D.deliveryTime ? ` <small>· tracked, ${esc(D.deliveryTime)}</small>` : ' <small>· tracked</small>'}</span><b class="is-free">FREE</b>`
      : '<span>Delivery</span><span class="gcart__line-r">Calculated at checkout</span>';

    // reassurance under the items: one real review + "what happens next"
    const aEl = $('GlowCartAssure');
    aEl.hidden = !count;
    // 14 Oct (Glow Pad): "What happens next" step 2 mentions stones, so a cart with no stones shows the general line instead
    // (cart drawer setting next_2_other). Carts with stones are unchanged.
    const alt2 = root.querySelector('[data-gc-next-other]');
    if (alt2) {
      alt2.hidden = !!stones;
      root.querySelectorAll('[data-gc-next-stones]').forEach(el => { el.hidden = !stones; });
    }
    const rEl = $('GlowCartReview');
    if (count && rEl && D.reviewsUrl) {
      loadReview().then(rv => {
        rEl.hidden = !rv;
        if (rv) rEl.innerHTML = `<span class="gcart__stars" role="img" aria-label="${rv.r} out of 5 stars">${'★'.repeat(rv.r)}${'☆'.repeat(5 - rv.r)}</span><blockquote>“${esc(rv.b)}”</blockquote><figcaption>– ${esc(rv.n)}</figcaption>`;
      });
    }

    // totals
    $('GlowCartTotal').textContent = money(cart.total_price);
    const wasTotal = was + (prot ? prot.final_line_price : 0);
    $('GlowCartWas').textContent = wasTotal > cart.total_price ? money(wasTotal) : '';
    const saved = wasTotal - cart.total_price;
    $('GlowCartSaved').hidden = saved <= 0;
    $('GlowCartSaved').textContent = `You saved ${money(saved)}`;
    root.classList.toggle('is-empty', !count); // empty cart: no footer, just the "Shop the sets" prompt
    $('GlowCartGo').classList.toggle('is-off', !count);
    $('GlowCartGo').classList.remove('is-going');
    if (!count) $('GlowCartGo').setAttribute('aria-disabled', 'true'); else $('GlowCartGo').removeAttribute('aria-disabled');
  }

  async function run(fn) {
    root.classList.add('is-busy');
    try { await fn(); } catch (e) { console.error(e); } finally { root.classList.remove('is-busy'); }
  }

  function open() {
    root.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('gcart-open'); // keeps the timed email popup from covering the cart (glow-cart.css)
    run(() => render());
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('gcart-open');
    setTimeout(() => { root.hidden = true; }, 260);
  }

  root.addEventListener('click', e => {
    if (e.target.closest('[data-close]')) return close();
    const go = e.target.closest('#GlowCartGo');
    if (go) { go.classList.add('is-going'); return; } // normal navigation to /checkout
    const wa = e.target.closest('[data-wand-add]');
    if (wa) return run(async () => {
      // the wand's own pre-order note rides along as a visible line item property, like the Glow Pad's
      const pre = D.wand && D.wand.pre ? String(D.wand.pre).replace(/^Pre-order:\s*/i, '') : '';
      await api('cart/add.js', { items: [{ id: Number(wa.dataset.wandAdd), quantity: 1, properties: pre ? { 'Pre-order': pre } : {} }] });
      await render();
    });
    const pa = e.target.closest('[data-pad-add]');
    if (pa) return run(async () => {
      const pre = D.pad && D.pad.pre ? String(D.pad.pre).replace(/^Pre-order:\s*/i, '') : '';
      await api('cart/add.js', { items: [{ id: Number(pa.dataset.padAdd), quantity: 1, properties: pre ? { 'Pre-order': pre } : {} }] });
      await render();
    });
    const plus = e.target.closest('[data-key]');
    if (plus) return run(async () => render(await api('cart/change.js', { id: plus.dataset.key, quantity: Number(plus.dataset.q) })));
    const q = e.target.closest('[data-line]');
    if (q) return run(async () => render(await api('cart/change.js', { line: Number(q.dataset.line), quantity: Number(q.dataset.q) })));
    const apply = e.target.closest('[data-apply]');
    if (apply) {
      // coupon "Apply": POST the code to the Ajax cart, re-read /cart.js and re-render (applied / "can't be used" note).
      // The /discount/ link in href is only the no-JS fallback.
      e.preventDefault();
      return run(async () => {
        try { await api('cart/update.js', { discount: apply.dataset.apply }); } catch (err) { console.error(err); }
        const c = await api('cart.js');
        if (couponState(c, apply.dataset.apply) !== 'applied') couponNote = true;
        await render(c);
      });
    }
    if (e.target.closest('[data-unapply]')) return run(async () => { await api('cart/update.js', { discount: '' }); await render(); });
    const add = e.target.closest('[data-add]');
    if (add) return run(async () => { await api('cart/add.js', { items: [{ id: Number(add.dataset.add), quantity: 1 }] }); await render(); });
    const up = e.target.closest('[data-upgrade]');
    if (up) return run(async () => {
      const toId = Number(up.dataset.to);
      const p = Object.values(products).find(x => x && x.variants.some(v => v.id === toId));
      const to = p && p.variants.find(v => v.id === toId);
      const unlocks = D.giftId && to && to.title === D.giftUnlock;
      await api('cart/change.js', { id: up.dataset.upgrade, quantity: 0 });
      const items = [{ id: toId, quantity: 1, properties: unlocks ? { _glow_unlock: '1' } : {} }];
      if (unlocks) items.push({ id: D.giftId, quantity: 1, properties: { _glow_gift: '1' } });
      await api('cart/add.js', { items });
      await render();
    });
  });
  $('GlowCartProtectToggle').addEventListener('change', e => run(async () => {
    const cart = await api('cart.js');
    const prot = cart.items.find(isProtect);
    if (e.target.checked && !prot) await api('cart/add.js', { items: [{ id: D.protectId, quantity: 1 }] });
    if (!e.target.checked && prot) await api('cart/change.js', { id: prot.key, quantity: 0 });
    await render();
  }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !root.hidden) close(); });

  // header cart icon (and any /cart link) opens the drawer instead of leaving the page
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href$="/cart"], a.glow-head__cart');
    if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); open(); }
  });

  window.GlowCart = { open, close, refresh: () => render() };
})();
